import { useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';

export const useCanUseProVoices = () => {
    const { user } = useAuth();

    return (
        user &&
        user.planGroup &&
        [
            PlanGroup.PRO,
            PlanGroup.ADVANCED,
            PlanGroup.ENTERPRISE,
            PlanGroup.ENTERPRISE_TRIAL,
            PlanGroup.CREATOR,
            PlanGroup.BUSINESS,
        ].includes(user.planGroup)
    );
};
